import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["product"];

  connect() {
    this.currentIndex = 0;
  }

  next() {
    this.show((this.currentIndex + 1) % this.productTargets.length);
  }

  prev() {
    this.show(
      (this.currentIndex - 1 + this.productTargets.length) %
        this.productTargets.length
    );
  }

  show(index) {
    this.productTargets.forEach((el, i) => {
      el.classList.toggle("active", i === index);
    });
    this.currentIndex = index;
  }
}
